import React from 'react';

export const SoundWave = ({ color = 'blue' }) => {
	const colorMap = {
		blue: 'bg-blue-500',
		emerald: 'bg-emerald-500',
		purple: 'bg-purple-500',
	};

	const bgColor = colorMap[color] || colorMap.blue;

	return (
		<div className="flex items-center gap-0.5 h-3.5">
			<div
				className={`w-0.5 ${bgColor} rounded-full animate-wave-1`}
				style={{ height: '40%' }}
			/>
			<div
				className={`w-0.5 ${bgColor} rounded-full animate-wave-2`}
				style={{ height: '70%' }}
			/>
			<div
				className={`w-0.5 ${bgColor} rounded-full animate-wave-3`}
				style={{ height: '50%' }}
			/>
			<div
				className={`w-0.5 ${bgColor} rounded-full animate-wave-4`}
				style={{ height: '90%' }}
			/>
			<div
				className={`w-0.5 ${bgColor} rounded-full animate-wave-1`}
				style={{ height: '45%' }}
			/>
			<div
				className={`w-0.5 ${bgColor} rounded-full animate-wave-2`}
				style={{ height: '65%' }}
			/>
			<style jsx>{`
				@keyframes wave {
					0%,
					100% {
						transform: scaleY(0.5);
					}
					50% {
						transform: scaleY(1);
					}
				}
				.animate-wave-1 {
					animation: wave 1.2s ease-in-out infinite;
				}
				.animate-wave-2 {
					animation: wave 1.2s ease-in-out infinite 0.15s;
				}
				.animate-wave-3 {
					animation: wave 1.2s ease-in-out infinite 0.3s;
				}
				.animate-wave-4 {
					animation: wave 1.2s ease-in-out infinite 0.45s;
				}
			`}</style>
		</div>
	);
};
